var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.9998 4.16663C20.8794 4.16663 16.8515 5.38848 13.4255 7.67768C9.99944 9.96687 7.32918 13.2206 5.75236 17.0274C4.17553 20.8342 3.76296 25.0231 4.56682 29.0643C5.37068 33.1056 7.35486 36.8178 10.2685 39.7314C13.182 42.6449 16.8942 44.6291 20.9355 45.433C24.9767 46.2369 29.1656 45.8243 32.9724 44.2475C36.7792 42.6706 40.0329 40.0004 42.3221 36.5743C44.6113 33.1483 45.8332 29.1204 45.8332 25C45.8332 22.2641 45.2943 19.555 44.2473 17.0274C43.2004 14.4998 41.6658 12.2031 39.7312 10.2686C37.7967 8.33401 35.5 6.79944 32.9724 5.75247C30.4448 4.7055 27.7357 4.16663 24.9998 4.16663ZM24.9998 41.6666C21.7035 41.6666 18.4812 40.6891 15.7403 38.8578C12.9995 37.0264 10.8633 34.4235 9.60185 31.378C8.34039 28.3326 8.01034 24.9815 8.65343 21.7485C9.29651 18.5154 10.8839 15.5457 13.2147 13.2148C15.5456 10.884 18.5153 9.29663 21.7483 8.65354C24.9814 8.01045 28.3325 8.34051 31.3779 9.60197C34.4233 10.8634 37.0263 12.9996 38.8577 15.7405C40.689 18.4813 41.6665 21.7036 41.6665 25C41.6665 29.4202 39.9106 33.6595 36.785 36.7851C33.6594 39.9107 29.4201 41.6666 24.9998 41.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 25H45.8333C45.8333 22.2641 45.2945 19.555 44.2475 17.0274C43.2005 14.4998 41.6659 12.2031 39.7314 10.2686C37.7968 8.33401 35.5002 6.79944 32.9726 5.75247C30.445 4.7055 27.7359 4.16663 25 4.16663V8.33329C29.4203 8.33329 33.6595 10.0892 36.7851 13.2148C39.9107 16.3405 41.6667 20.5797 41.6667 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.8338fbc8b5a1d359bb1e9a0429b9a52f.svg";
export { ForwardRef as ReactComponent };